<script>
import Dexie from 'dexie';
import { marked } from 'marked';
import { markedHighlight } from 'marked-highlight';
import hljs from 'highlight.js';
import moment from "moment";
import 'highlight.js/styles/github.css';
import * as CryptoJS from 'crypto-js';

export default {
  name: "index",
  data() {
    return {
      dbClient: null,
      btnDisabled: false,
      inputValue: '',
      chatList: [],
      sessionId: '',
      language: 'zh-CN',
      timeFlag: null,
      interactiveFlag: false,
      interactiveTime: null,
      userInfo: {}
    }
  },
  created() {
    this.dbClient = new Dexie('H5_GPT_DATA_HE_TU');
    this.dbClient.version(1).stores({
      MessageList: '++id,sessionId,bot,content,time',
    });
    this.initMarkedOptions();
    this.getChatListFromIndexDB();
    this.language = window.navigator.language || window.navigator.userLanguage;
    this.getUrlInfo();
  },
  mounted() {
    this.timeFlag = setInterval(() => {
      this.refreshTime();
    }, 1000*60)

    window.document.querySelector('.he-tu-h5-chat-outer').addEventListener('click', this.hrefClickFn, true)
  },
  beforeDestroy() {
    if (this.timeFlag) {
      clearInterval(this.timeFlag);
    }
    window.document.querySelector('.he-tu-h5-chat-outer').removeEventListener('click', this.hrefClickFn);
  },
  methods: {
    hrefClickFn(e) {
      if (e.target.tagName === 'A') {
        e.preventDefault();
        window.open(e.target.href, '_blank');
      }
    },
    getUrlInfo() {
      this.userInfo = this.$route.query || {};
    },
    scrollToBottom() {
      const container = this.$refs.scrollContainer;
      container.scrollTop = container.scrollHeight;
    },
    async generateSignature(appSecret, timestamp, messageBody) {
      // const encoder = new TextEncoder();
      // const keyData = encoder.encode(appSecret);
      // const key = await crypto.subtle.importKey(
      //   'raw',
      //   keyData,
      //   { name: 'HMAC', hash: { name: 'SHA-256' } },
      //   true,
      //   ['sign']
      // );
      // const signatureData = encoder.encode(timestamp + messageBody);
      // const signature = await crypto.subtle.sign('HMAC', key, signatureData);
      // return Array.from(new Uint8Array(signature))
      //   .map(b => b.toString(16).padStart(2, '0'))
      //   .join('');
      const keyData = CryptoJS.enc.Utf8.parse(appSecret);
      // 将timestamp和messageBody连接后进行HMAC-SHA256签名
      const message = timestamp + messageBody;
      const signature = await CryptoJS.HmacSHA256(message, keyData);
      // 将签名结果转换为十六进制字符串
      return signature.toString(CryptoJS.enc.Hex);
    },
    async getHeaders(messageBody) {
      const appId = '1011475156173373442';
      const appSecret = 'a893ab1ca89249b4b33c32486c0ae9da';
      const timestamp = new Date().getTime().toString();
      const signatureData = await this.generateSignature(appSecret, timestamp, messageBody);
      return {
        signature: signatureData,
        appid: appId,
        timestamp,
      }
    },
    getHtml(content) {
      return content && marked.parse(content)
    },
    initMarkedOptions() {
      const markedOptions = markedHighlight({
        langPrefix: 'hljs language-',
        highlight(code, lang) {
          const language = hljs.getLanguage(lang) ? lang : 'javascript';
          return hljs.highlight(code, { language }).value;
        },
      });
      marked.use({
        ...markedOptions,
      });
    },
    formSubmit(e) {
      e.preventDefault();
      if (this.inputValue === '') return;
      this.sendTextMessage();
    },
    refreshTime() {
      let newChatList = JSON.parse(JSON.stringify(this.chatList));
      this.chatList = newChatList.map((chat) => {
        if (chat.time) {
          return {
            ...chat,
            content: new Date().getTime()
          }
        } else {
          return chat;
        }
      })
    },
    getTimeShow(timeStr) {
      let nowDate = moment();
      let showStrDate = moment(timeStr);
      let str = moment(timeStr).format('YYYY-MM-DD HH:mm:ss');
      const daysDiff = nowDate.diff(showStrDate, 'days');
      const hoursDiff = nowDate.diff(showStrDate, 'hours');
      const minutesDiff = nowDate.diff(showStrDate, 'minutes');
      if (daysDiff === 1) {
        str = 'yesterday'
      }
      if (nowDate.isSame(showStrDate, 'day')) {
        if (hoursDiff < 1) {
          str = `${minutesDiff} minutes ago`
        } else {
          str = `${hoursDiff} hours ago`
        }
      }
      if (nowDate.isSame(showStrDate, 'hour')) {
        if (minutesDiff <= 0) {
          str = 'just now'
        } else {
          str = `${minutesDiff} minutes ago`
        }
      }
      return str;
    },
    async sendTextMessage() {
      const scopeId = this.$options._scopeId;
      const sendMessage = this.inputValue;
      this.inputValue = '';
      this.btnDisabled = true;
      const userChatId = this.chatList.length + 1;
      const bobChatId = this.chatList.length + 2;
      const timeId = moment().format('YYYY-MM-DD HH:mm:ss')
      if (!this.interactiveFlag) {
        this.chatList.push({
          id: timeId,
          time: timeId,
          content: ''
        })
      }
      if (this.interactiveTime) {
        clearTimeout(this.interactiveTime);
      }
      this.chatList.push({
        id: userChatId,
        bot: false,
        content: sendMessage
      }, {
        id: bobChatId,
        bot: true,
        content: `<div class="loader" ${scopeId}></div>`
      })
      setTimeout(() => {
        this.scrollToBottom();
      }, 0)
      await this.dbClient.MessageList.put({
        sessionId: this.sessionId,
        bot: false,
        time: timeId,
        content: ''
      })
      this.interactiveFlag = true;
      this.interactiveTime = setTimeout(() => {
        this.interactiveFlag = false;
      }, 1000*60*5)
      await this.dbClient.MessageList.put({
        sessionId: this.sessionId,
        bot: false,
        content: sendMessage
      })
      const otherInfo = {};
      Object.keys(this.userInfo).forEach(key => {
        if (this.userInfo[key]) {
          if (key === 'mobile') {
            otherInfo.phone = this.userInfo[key];
          } else {
            otherInfo[key] = this.userInfo[key];
          }
        }
      })
      const messageBody = JSON.stringify({
        sessionId: this.sessionId,
        message: sendMessage,
        ...otherInfo
      })
      const header = await this.getHeaders(messageBody)
      fetch('/a2p/api/v1/chatH5', {
        method: 'POST',
        headers: header,
        body: messageBody
      })
        .then(res => {
          return res.json()
        })
        .then(data => {
          this.btnDisabled = false;
          const modifyIndex = this.chatList.findIndex(item => item.id === bobChatId);
          this.chatList.splice(modifyIndex, 1, {
            ...this.chatList[modifyIndex],
            content: data.reply
          })
          setTimeout(() => {
            this.scrollToBottom();
          }, 0)
          this.dbClient.MessageList.put({
            sessionId: this.sessionId,
            bot: true,
            content: data.reply
          })
        })
        .catch(() => {
          this.btnDisabled = false;
        })
    },
    async getChatListFromIndexDB() {
      // 看看当前是否缓存有聊天记录
      const list = await this.dbClient.MessageList.toArray();
      this.chatList = list || [];
      let deviceId = localStorage.getItem('deviceId');
      if (!deviceId && list.length === 0) {
        deviceId = 'device_' + Date.now() + Math.random().toString(36).substring(2);
        localStorage.setItem('deviceId', deviceId);
        const welcomeMessage = `<div>Please leave your question in the chatbot and I'll try my best to answer it accordingly. Or you can type 'transfer to agent'</div>`
        this.chatList.push({
          id: 1,
          bot: true,
          content: welcomeMessage
        })
        await this.dbClient.MessageList.put({
          sessionId: this.sessionId,
          bot: true,
          content: welcomeMessage
        })
      }
      if (!deviceId && list.length > 0) {
        // 用户清除了id 但是还没有清除回话
        deviceId = list[0].sessionId;
        localStorage.setItem('deviceId', deviceId);
      }
      this.sessionId = deviceId;
      setTimeout(() => {
        this.scrollToBottom();
      }, 0)
    }
  }
}
</script>

<template>
  <div class="he-tu-h5-chat-outer">
    <div class="chat-header">
      <img src="./bot.png" alt="">Whale Chat
    </div>
    <div class="chat-content" ref="scrollContainer">
      <div class="chat-list">
        <div :class="`${item.bot ? 'bot ' : ''}chat-item`" v-for="item in chatList" :key="item.id">
          <div v-if="item.time" style="text-align: center;width: 100%" :data-tiem="item.content">
            {{getTimeShow(item.time)}}
          </div>
          <template v-else>
            <div class="chat-item-image">
              <img :src="item.bot ? require('./bot.png') : require('./yonghu1.png')" alt="">
            </div>
            <div class="chat-item-content-outer">{{item.name}}
              <p :style="{textAlign: item.bot ? 'left' : 'right'}">{{item.bot ? 'Whale Chat' : (userInfo.name || '')}}</p>
              <div class="chat-item-content" v-html="getHtml(item.content)"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <form action="#" @submit="formSubmit">
      <div class="send-outer">
        <input
          :placeholder="language === 'zh' ? '请输入内容' : 'Please enter the content'"
          v-model="inputValue"
          class="el-input__inner innerInput"
        />
        <el-button
          htmlType="button"
          :disabled="!inputValue || btnDisabled"
          class="send-btn"
          @click="sendTextMessage"
        >{{language === 'zh' ? '发送' : 'Send'}}</el-button>
      </div>
    </form>
    <div class="copyright-outer">
      <img src="../assets/logo-wight.png" alt="">
      <a href="https://online.iwhalecloud.com/software/hetu-message-paas" target="_blank">
        Powered by Whale Cloud HETU CPaaS
      </a>
    </div>
  </div>
</template>

<style scoped lang="less">
.he-tu-h5-chat-outer {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: Roboto-Light;
  /deep/ p {
    margin: 0;
  }
  .chat-header {
    box-sizing: border-box;
    width: 100%;
    height: 48px;
    background: #50A3FF;
    display: flex;
    align-items: center;
    padding: 0 16px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    img {
      display: block;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      margin-right: 5px;
    }
  }
  .chat-content {
    flex: 1;
    box-sizing: border-box;
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;
    background: #f8f8f8;
    .chat-list {
      display: flex;
      flex-direction: column;
      .chat-item {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row-reverse;
        &.bot {
          flex-direction: row;
          .chat-item-content-outer {
            margin-left: 5px;
          }
          .chat-item-content {
            border-radius: 0 15px 15px 15px;
            color: #333;
            background: #eee;
            /deep/ img {
              width: 100%;
            }
          }
        }
        .chat-item-image {
          img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
        }
        .chat-item-content-outer {
          margin-right: 5px;
          max-width: 82%;
        }
        .chat-item-content {
          box-sizing: border-box;
          padding: 8px 15px;
          background: #8b57ea;
          border-radius: 15px 0 15px 15px;
          color: #fff;
          text-align: left;
          font-size: 14px;
          line-height: 22px;
        }
      }
    }
  }
  .send-outer {
    width: 100%;
    box-sizing: border-box;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 10px;
    background: #fff;
    .send-btn {
      height: 40px;
      padding: 8px;
      background-color: #f3f3f3;
      border-radius: 0 4px 4px 0;
      border: 1px solid #dcdfe6;
    }
  }
  .copyright-outer {
    width: 100%;
    padding: 10px;
    background: #F9F9F9;
    color: #666;
    text-align: center;
    box-sizing: border-box;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
    a {
      color: #666;
      text-decoration: none;
    }
  }
}

.loader {
  width: 30px;
  aspect-ratio: 2;
  --_g: no-repeat radial-gradient(circle closest-side,#000 90%,#0000);
  background:
    var(--_g) 0%   50%,
    var(--_g) 50%  50%,
    var(--_g) 100% 50%;
  background-size: calc(100%/3) 50%;
  animation: l3 1s infinite linear;
}
@keyframes l3 {
  20%{background-position:0%   0%, 50%  50%,100%  50%}
  40%{background-position:0% 100%, 50%   0%,100%  50%}
  60%{background-position:0%  50%, 50% 100%,100%   0%}
  80%{background-position:0%  50%, 50%  50%,100% 100%}
}
</style>



// WEBPACK FOOTER //
// src/newChat/index.vue